// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"ea2966b5","808":"12f7d020"}[chunkId] + ".chunk.js";
};